import type { HTMLAttributes } from 'react';
import { cn } from '@/utils/helpers';

export type SkeletonProps = HTMLAttributes<HTMLDivElement>;

export default function Skeleton({ className, ...props }: SkeletonProps) {
  return <div aria-hidden {...props} className={cn('ui-skeleton', className)} />;
}

